/**
 * The door to the `signin-security-client` chunk: the web's side of the sign-in security doors
 * (./signInSecurityClient.ts, with the readers it answers through). Fetched only when a surface asks a door something:
 * the countdown in the banner band (which is on the first download) once someone is signed in where the lever admits
 * them, Team & Roles once a member who may help others sign in has read the roster, and Portal Controls once it has
 * read the account. Every one of them reaches the client here and nowhere else, so the client is downloaded once and
 * rides none of their files (scripts/check-chat-first-paint.mjs, R4). It holds nothing but the one dynamic import.
 */
import { createOnDemandModule } from '../../utils/onDemandModule';
// TYPE-only imports: erased at build, never an edge into the chunk.
import type * as SignInSecurityClientNamespace from './signInSecurityClient';
import type { SignInSecurityClient } from './signInSecurityClient';

const client = createOnDemandModule<typeof SignInSecurityClientNamespace>(
  () => import(/* webpackChunkName: "signin-security-client" */ './signInSecurityClient'),
);

/** The client, fetched now if it has not arrived (one download per page, shared). Rejects only if the chunk cannot be had. */
export async function loadSignInSecurityClient(): Promise<SignInSecurityClient> {
  const mod = await client.load();
  return mod.signInSecurityClient();
}

/** Tests only: forget the download. */
export const resetSignInSecurityClientForTests = client.resetForTests;
